import { z } from 'zod';

/**
 * Validation schema for the Club Selection step.
 */
export const clubSelectionStepSchema = z.object({
  selectedClub: z
    .object({
      id: z.string().min(1),
      name: z.string(),
      courts: z.array(z.any()).min(1, 'El club debe tener al menos una cancha'),
    })
    .nullable()
    .refine((val) => val !== null, {
      message: 'Debes seleccionar un club',
    }),
  clubs: z.array(z.any()),
});

export type ClubSelectionStepData = z.infer<typeof clubSelectionStepSchema>;
